<template>
  <a
    class="listItem"
    :class="[
      {
        'three-line': linkLocation,
        search_result: item.id == $route.query.show,
        'item-active': index == $store.state.search.active_index,
        'contents-hidden': item.hidden && !unlocked,
      },
      'layout-' + $store.state.user.layouts[$store.state.user.selectedLayout].class,
    ]"
    :id="item.id"
    :data-type="item.type"
    @click="$store.dispatch('clickItem', item)"
    @dragstart="dragstart"
    @dragend="dragend"
    @dragenter="dragenter"
    @dragleave="dragleave"
    @drop="drop($event, item.id)"
  >
    <div class="thumbnail" v-if="$store.state.user.selectedLayout == 3">
      <template v-if="item.type == 'folder'">
        <v-icon color="primary" size="6rem">
          {{ !item.hidden ? "mdi-folder" : "mdi-folder-lock" }}
        </v-icon>
      </template>
      <template v-else-if="item.type == 'url'">
        <template v-if="item.url !== null && item.url !== '' && item.url !== 'null'">
          <v-avatar size="100" color="rgb(132 132 132 / 11%)">
            <v-img
              max-width="150"
              max-height="150"
              rounded
              :src="`https://logo.clearbit.com/${thumbnailUrl}?size=150`"
            ></v-img>
          </v-avatar>
        </template>
        <template v-else>
          <v-icon color="primary" size="6rem">mdi-text-box-outline</v-icon>
        </template>
      </template>
    </div>
    <div class="flex-grow-1 d-flex justify-start align-stretch text-truncate mainContent">
      <div
        class="flex-shrink-0 iconBox d-flex justify-center align-center"
        v-if="edit_mode"
        @click.stop="$store.commit('toggleSelected', item.id)"
      >
        <v-icon color="primary" v-if="!item.selected">mdi-checkbox-blank-outline</v-icon>
        <v-icon color="primary" v-else>mdi-checkbox-marked</v-icon>
      </div>
      <div
        class="flex-shrink-0 iconBox d-flex justify-center align-center handle"
        @click.stop="iconClick(item.id)"
      >
        <template v-if="item.type == 'folder'">
          <v-icon color="primary">{{ !item.hidden ? "mdi-folder" : "mdi-folder-lock" }}</v-icon>
        </template>
        <template v-else-if="item.type == 'url'">
          <template v-if="item.url !== null && item.url !== ''">
            <v-img
              max-width="16"
              max-height="16"
              rounded
              :src="`https://www.google.com/s2/favicons?domain=${item.url}`"
            ></v-img>
          </template>
          <template v-else>
            <v-icon color="primary">mdi-text-box-outline</v-icon>
          </template>
        </template>
      </div>
      <div class="d-flex justify-start align-center text-truncate">
        <div class="pl-2 text-truncate">
          <div class="d-flex justify-start align-center">
            <v-icon color="primary" class="small_edit_icon mr-1" small v-if="edit_mode">
              mdi-pencil
            </v-icon>
            <div
              class="text-truncate label lockableTextField"
              :class="{ 'font-weight-bold': item.type == 'folder' }"
              :title="item.label"
              v-if="item.label !== null && item.label !== ''"
              v-html="$options.filters.highlight(item.label, $store.getters.search_regex)"
            ></div>
            <div
              class="text-truncate label font-italic"
              :class="{ 'font-weight-bold': item.type == 'folder' }"
              :title="item.label"
              v-else-if="item.note !== null && item.note !== ''"
              v-html="$options.filters.highlight(item.note, $store.getters.search_regex)"
            ></div>
          </div>
          <div
            v-if="item.type == 'url'"
            class="grey--text text-truncate url"
            :title="item.url"
            v-html="$options.filters.highlight(item.url, $store.getters.search_regex)"
          ></div>
          <div
            v-if="linkLocation"
            class="primary--text text-truncate location"
            :title="item.search_string"
          >
            <v-icon color="primary" class="small_edit_icon" x-small>mdi-map-marker</v-icon>
            <span
              class="lockableTextField"
              v-html="$options.filters.highlight(item.search_string, $store.getters.search_regex)"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-shrink-0 d-flex justify-start align-stretch actionButtons">
      <div
        class="iconBox d-flex justify-center align-center"
        @click.stop="goToFolder(item.parent, item.id)"
        v-if="linkLocation"
      >
        <v-icon color="primary">mdi-folder-marker-outline</v-icon>
      </div>

      <v-menu
        v-model="popup_note"
        offset-y
        :close-on-content-click="false"
        :close-on-click="true"
        :nudge-bottom="10"
        min-width="200"
        max-width="400"
        left
        v-if="item.note && !$store.getters.if_search"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="iconBox d-flex justify-center align-center" v-bind="attrs" v-on="on">
            <v-icon :color="ifNoteTextIsSearched ? 'success' : 'primary'">mdi-note-outline</v-icon>
          </div>
        </template>

        <v-card
          :class="[
            {
              'contents-hidden': item.hidden && !unlocked,
            },
          ]"
        >
          <v-card-title class="primary py-0 pr-2">
            <div class="d-flex justify-space-between align-center w-full">
              <div class="white--text text-overline">NOTE</div>
              <div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        dark
                        x-small
                        class="mr-4"
                        @click="
                          $store.dispatch('copy', { text: item.note, message: 'Note Copied!' })
                        "
                      >
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>Copy Note</span>
                </v-tooltip>
                <v-btn icon dark small>
                  <v-icon @click="popup_note = false">mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-title>
          <v-card-text
            style="white-space: break-spaces;"
            class="mt-3 note lockableTextField"
            v-html="$options.filters.highlight(item.note, $store.getters.search_regex)"
            >{{ item.note }}</v-card-text
          >
        </v-card>
      </v-menu>
    </div>

    <div class="dropArea d-none"></div>
  </a>
</template>

<script>
export default {
  name: "ListItem",
  props: {
    item: {
      required: true,
      type: Object,
    },
    highlight: {
      type: String,
      default: "",
    },
    linkLocation: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: -1,
    },
    unlocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popup_note: false,
    };
  },
  computed: {
    edit_mode: {
      get() {
        return this.$store.state.edit_mode;
      },
      set(value) {
        this.$store.commit("updateStateVariable", { edit_mode: value });
      },
    },
    thumbnailUrl() {
      let hostname = "mychordbook.com";
      try {
        const url = new URL(this.item.url);
        hostname = url.hostname;
      } catch (e) {
        console.info("invalid URL");
      }
      return hostname;
    },
    ifNoteTextIsSearched() {
      const regexp = new RegExp(this.$store.getters.search_regex, "i");
      return (
        this.$store.getters.if_search &&
        this.item.note !== null &&
        this.item.note !== "" &&
        regexp.test(this.item.note)
      );
    },
  },
  methods: {
    iconClick(item_id) {
      if (!this.$store.getters.if_search) {
        this.$store.commit("iconClick", item_id);
      }
    },
    goToFolder(parent, id) {
      this.$store.commit("updateStateSearch", { search: null });
      this.$router.push(`/bookmarks/${parent}?show=${id}`);
    },
    dragstart(e) {
      // console.log("dragstart");
      // console.log(e);

      // make dropAres visible
      let $drops = document.querySelectorAll(".dropArea");
      for (let i = 0; i < $drops.length; i++) {
        $drops[i].classList.remove("d-none");
        // console.log("dropAreas visible");
      }

      // store dragged item id
      this.$store.commit("updateStateVariable", {
        drag_id: e.target.closest(".listItem").id,
      });
      // e.target.closest(".listItem").classList.add("primary-border");
    },
    dragend(e) {
      // console.log("dragend");
      // console.log(e);

      // hide drag areas
      let $drops = document.querySelectorAll(".dropArea");
      for (let i = 0; i < $drops.length; i++) {
        $drops[i].classList.add("d-none");
        // console.log("dropAreas hidden");
        // remove all bordered styles
        let item = $drops[i].closest(".listItem");
        if (item) item.classList.remove("primary-border");
      }

      // remove all dragItem (dataTransfer image) items created on drag start (listItem setDate())
      let $dragItems = document.querySelectorAll(".dragItem");
      for (let i = 0; i < $dragItems.length; i++) {
        $dragItems[i].remove();
      }

      // delete drag id in the state
      this.$store.commit("updateStateVariable", {
        drag_id: null,
        drag_on_folder: false,
      });
    },
    dragenter(e) {
      console.log("dragenter");
      if (!this.$store.state.drag_id) return;
      let type = e.target.closest(".listItem").getAttribute("data-type");

      if (type == "folder") {
        let dragged_on_id = e.target.closest(".listItem").id;
        // if dragged item is not self and it is a folder add border
        if (dragged_on_id != this.$store.state.drag_id) {
          e.target.closest(".listItem").classList.add("primary-border");
          this.$store.commit("updateStateVariable", {
            drag_on_folder: true,
          });
          console.log("order disabled");
        }
      }
    },
    dragleave(e) {
      console.log("dragleave");
      if (!this.$store.state.drag_id) return;
      let type = e.target.closest(".listItem").getAttribute("data-type");
      if (type == "folder") {
        let dragged_on_id = e.target.closest(".listItem").id;
        // if dragged item is not self and it is a folder add border
        if (dragged_on_id != this.$store.state.drag_id) {
          e.target.closest(".listItem").classList.remove("primary-border");
          this.$store.commit("updateStateVariable", {
            drag_on_folder: false,
          });
          console.log("order enabled");
        }
      }
    },
    async drop(e, folder_id) {
      e.preventDefault();
      console.log("drop");
      let type = e.target.closest(".listItem").getAttribute("data-type");
      let item_id = e.dataTransfer.getData("item_id");
      console.log(item_id, "item_id");
      console.log(folder_id, "folder_id");

      if (type == "folder") {
        // console.log(e);
        e.target.closest(".listItem").classList.remove("primary-border");

        try {
          await this.$store.dispatch("moveItems", {
            items: [this.$store.getters.whole_list.find((g) => g.id == item_id)],
            parent_id: folder_id,
          });
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
};
</script>

<style>
.listItem {
  /* background-color: yellow;
  margin-bottom: 1rem; */
  height: 3.1rem;
  border-radius: 0.6rem;
  overflow: hidden;
  position: relative;
  /* corrupts everything about drag and drop */
  border: none !important;
}
.listItem.layout-vertical {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.listItem.layout-horizontal-fixed {
  display: inline-flex;
  width: 19rem;
  margin: 0 1rem 1rem 0;
}
.listItem.layout-horizontal-auto {
  display: inline-flex;
  width: auto;
  margin: 0 1rem 1rem 0;
}
.listItem.layout-thumbnails {
  display: inline-flex;
  width: 12rem;
  height: 12rem;
  margin: 0 1rem 1rem 0;
  flex-wrap: wrap;
  vertical-align: top;
  border: 1px solid #80808061 !important;
}
.listItem .thumbnail {
  display: none;
}
.listItem.layout-thumbnails .thumbnail {
  /* background-color: blue; */
  display: flex;
  width: 100%;
  height: 8rem;
  justify-content: center;
  align-items: center;
}
.listItem.layout-thumbnails .mainContent {
  height: 4rem;
}
.listItem.layout-thumbnails .actionButtons {
  position: absolute;
  top: 0;
  right: 0;
  height: 3rem;
}
.listItem.layout-horizontal-vertical.three-line,
.listItem.layout-horizontal-fixed.three-line,
.listItem.layout-horizontal-auto.three-line {
  height: 4rem;
}
.listItem.layout-thumbnails.three-line {
  height: 12rem;
}
.listItem.search_result {
  background-color: rgba(114, 114, 114, 0.267);
}
.listItem.three-line {
  height: 3.8rem;
}
.listItem:hover {
  background-color: rgba(128, 128, 128, 0.11);
  cursor: pointer;
}
.iconBox {
  width: 3.1rem;
}
.iconBox:hover {
  background-color: rgba(128, 128, 128, 0.144);
}
.listItem .label {
  line-height: 1.3rem;
}
.listItem .url {
  font-size: 0.75rem;
  line-height: 0.9rem;
}
.listItem .location {
  font-size: 0.75rem;
  line-height: 0.9rem;
  margin-top: 0.1rem;
}
.small_edit_icon {
  position: relative;
  bottom: 0.1rem;
}
.handle {
  cursor: move;
}
</style>
